var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.loading && _vm.currentPageData)?_c('router-view',{attrs:{"pageData":_vm.currentPageData}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }